import * as z from 'zod'
import { GetApiContract, PatchApiContract, PostApiContract } from './ApiContract.js'
import { UserEntity, UserMe } from '../Users.js'
import { userSettingsSchema } from '../UsersSettings.js'

export interface GetUserMeRequest extends GetApiContract {
    Response: UserMe
    ResponseJson: UserMe
}

export interface GetUserListRequest extends GetApiContract {
    Response: Array<UserEntity>
    ResponseJson: Array<UserEntity>
    QueryParameters: { customerId: string }
}

export interface GetUserMeEncryptionKeyRequest extends GetApiContract {
    Response: { encryptionKey: string }
    ResponseJson: { encryptionKey: string }
}

export const patchUserMeBodySchema = z.object({
    password: z
        .object({
            currentPassword: z.string(),
            newPassword: z.string(),
        })
        .optional(),
    settings: userSettingsSchema.optional(),
})

export interface PatchUserMeRequest extends PatchApiContract {
    Body: z.infer<typeof patchUserMeBodySchema>
    Response: UserMe
    ResponseJson: UserMe
}

export const patchUserBodySchema = z.object({
    customerId: z.string().optional().nullable(),
    disabled: z.boolean().optional(),
    password: z.string().optional(),
    userCategory: z.string().optional(),
})

export interface PatchUserRequest extends PatchApiContract {
    Body: z.infer<typeof patchUserBodySchema>
    Response: { message: string }
    ResponseJson: { message: string }
}

export const postUserBodySchema = z.object({
    email: z.email(),
    name: z.string(),
    password: z.string(),
    customerId: z.string().optional().nullable(),
    userCategory: z.string().optional(),
})

export interface PostUserRequest<
    R = {
        user: {
            userId: string | null
            username: string
            email: string
            name: string
            createdAt?: string
        }
    },
> extends PostApiContract {
    Body: z.infer<typeof postUserBodySchema>
    Response: R
    ResponseJson: R
}

export const postUserRequestResetPassword = z.object({
    email: z.string(),
})

export interface PostUserRequestResetPassword extends PostApiContract {
    Body: z.infer<typeof postUserRequestResetPassword>
}

export const postUserPasswordSchema = z.object({
    code: z.string(),
    email: z.string(),
    password: z.string(),
})

export interface PostUserResetPassword extends PostApiContract {
    Body: z.infer<typeof postUserPasswordSchema>
}
